'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PaintActionContainer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DrawingModes = require('./DrawingModes');

var _Utils = require('./Utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaintActionContainer = exports.PaintActionContainer = function (_Component) {
    _inherits(PaintActionContainer, _Component);

    function PaintActionContainer(props) {
        _classCallCheck(this, PaintActionContainer);

        var _this = _possibleConstructorReturn(this, (PaintActionContainer.__proto__ || Object.getPrototypeOf(PaintActionContainer)).call(this, props));

        _this.isRect = function (e) {
            return _this.props.mode !== _DrawingModes.BRUSH && (e.shiftKey || _this.props.shape === _DrawingModes.RECT);
        };

        _this.handleMouseDown = function (e) {
            if (e.nativeEvent.which === 3 || e.type === 'contextmenu') {
                return;
            }
            e.preventDefault();
            var _this$props = _this.props,
                mode = _this$props.mode,
                brushColor = _this$props.brushColor,
                brushBlur = _this$props.brushBlur,
                brushSize = _this$props.brushSize,
                onMouseDown = _this$props.onMouseDown,
                historyProps = _this$props.historyProps;

            var x = (0, _Utils.getMouseX)(e);
            var y = (0, _Utils.getMouseY)(e);

            var rect = _this.isRect(e);
            var action = {
                brushColor: brushColor,
                brushSize: brushSize,
                brushBlur: brushBlur,
                path: [{ x: x, y: y }],
                mode: mode,
                historyProps: historyProps,
                shape: rect ? _DrawingModes.RECT : _DrawingModes.FREEHAND
            };
            if (onMouseDown) {
                onMouseDown(x, y, action);
            }
            _this.setState({ drawing: true, action: action, rect: rect });
        };

        _this.handleMouseMove = function (e) {
            var _this$state = _this.state,
                drawing = _this$state.drawing,
                action = _this$state.action,
                rect = _this$state.rect;

            if (!drawing) {
                return;
            }
            var x = (0, _Utils.getMouseX)(e);
            var y = (0, _Utils.getMouseY)(e);

            if (action) {
                if (rect) {
                    action.path[1] = { x: x, y: y };
                } else {
                    action.path.push({ x: x, y: y });
                }
            }

            if (_this.props.onMouseMove) {
                _this.props.onMouseMove(x, y, action);
            }
            _this.setState({ action: action });
        };

        _this.handleMouseUp = function (e) {
            var _this$state2 = _this.state,
                action = _this$state2.action,
                rect = _this$state2.rect;


            if (rect && action) {
                var x = (0, _Utils.getMouseX)(e);
                var y = (0, _Utils.getMouseY)(e);
                action.path[1] = { x: x, y: y };
            }

            if (_this.props.onMouseUp) {
                _this.props.onMouseUp(action);
            }

            _this.setState({
                drawing: false,
                action: undefined
            });
        };

        _this.render = function () {
            var _this$props2 = _this.props,
                width = _this$props2.width,
                height = _this$props2.height,
                style = _this$props2.style,
                mode = _this$props2.mode,
                shape = _this$props2.shape,
                brushColor = _this$props2.brushColor,
                brushSize = _this$props2.brushSize,
                brushBlur = _this$props2.brushBlur,
                onMouseDown = _this$props2.onMouseDown,
                onMouseMove = _this$props2.onMouseMove,
                onMouseUp = _this$props2.onMouseUp,
                historyProps = _this$props2.historyProps,
                containerProps = _objectWithoutProperties(_this$props2, ['width', 'height', 'style', 'mode', 'shape', 'brushColor', 'brushSize', 'brushBlur', 'onMouseDown', 'onMouseMove', 'onMouseUp', 'historyProps']);

            var disabled = mode !== _DrawingModes.BRUSH && mode !== _DrawingModes.LASSO && mode !== _DrawingModes.INVERSE;
            var _this$state3 = _this.state,
                drawing = _this$state3.drawing,
                action = _this$state3.action;

            return _react2.default.createElement(
                'div',
                _extends({ ref: function ref(c) {
                        return _this.container = c;
                    },
                    onMouseDown: disabled ? undefined : _this.handleMouseDown,
                    onTouchStart: disabled ? undefined : _this.handleMouseDown,
                    onMouseMove: disabled ? undefined : _this.handleMouseMove,
                    onTouchMove: disabled ? undefined : _this.handleMouseMove,
                    onMouseUp: disabled ? undefined : _this.handleMouseUp,
                    onTouchEnd: disabled ? undefined : _this.handleMouseUp,
                    style: _extends({}, style, { width: width, height: height })
                }, containerProps),

                // using the "Children-as-Function" pattern: https://medium.com/merrickchristensen/function-as-child-components-5f3920a9ace9
                _this.props.children(drawing, action)
            );
        };

        _this.state = {
            drawing: false,
            action: undefined,
            rect: false
        };
        return _this;
    }

    return PaintActionContainer;
}(_react.Component);

PaintActionContainer.propTypes = {
    children: _propTypes2.default.func.isRequired, // using the "Children-as-Function" pattern: https://medium.com/merrickchristensen/function-as-child-components-5f3920a9ace9
    width: _propTypes2.default.number.isRequired,
    height: _propTypes2.default.number.isRequired,
    brushColor: _propTypes2.default.string,
    brushSize: _propTypes2.default.number,
    mode: _propTypes2.default.string,
    shape: _propTypes2.default.oneOf([_DrawingModes.RECT, _DrawingModes.FREEHAND]),
    brushBlur: _propTypes2.default.number,
    onMouseDown: _propTypes2.default.func,
    onMouseMove: _propTypes2.default.func,
    onMouseUp: _propTypes2.default.func,
    historyProps: _propTypes2.default.object
};
PaintActionContainer.defaultProps = {
    brushColor: '#000000',
    brushSize: 4,
    brushBlur: 0
};


//////////////////
// WEBPACK FOOTER
// ../rc-canvas/lib/PaintActionContainer.js
// module id = 1223
// module chunks = 0